<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import {
	DialogClose,
	DialogContent,
	type DialogContentEmits,
	type DialogContentProps,
	DialogOverlay,
	DialogPortal,
	useForwardPropsEmits,
} from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const { class: rawClass, ...props } = defineProps<DialogContentProps & { class?: HTMLAttributes["class"], hideClose?: boolean }>()
const emits = defineEmits<DialogContentEmits>()

const forwarded = useForwardPropsEmits(() => props, emits)

const className = useClass(
	"fixed left-1/2 top-1/2 z-50 grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-48% data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-48% sm:rounded-lg",
	() => rawClass,
)
</script>

<template>
	<DialogPortal>
		<DialogOverlay
			class="fixed inset-0 z-50 data-[state=closed]:animate-out data-[state=open]:animate-in bg-background/80 backdrop-blur-sm data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0" />

		<DialogContent
			v-bind="forwarded"
			:class="className">
			<slot />

			<DialogClose
				v-if="!hideClose"
				class="absolute end-4 top-4 flex items-center rounded-sm opacity-70 transition-opacity disabled:pointer-events-none hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ring">
				<Icon name="i-mdi:close-circle-outline" />

				<span class="sr-only">Close</span>
			</DialogClose>
		</DialogContent>
	</DialogPortal>
</template>
